import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../abstract/base.service';
import { SponsorLocation } from '../data-models/sponsor-location.model';
import { SponsorLocationCreateRequest } from '../request-models/sponsor-location-create-request.model';
import { SponsorLocationUpdateRequest } from '../request-models/sponsor-location-update-request.model';
import { toSponsorLocationCreateRequest, toSponsorLocationUpdateRequest } from '../utils/sponsor-request-utils';
import { sponsorPrefix } from '../utils/sponsor-path-utils';

/** A sponsor's physical locations: `/admin/sponsors/:sponsorId/locations` (hub `admin-sponsors-controller.ts`). */
@Injectable({ providedIn: 'root' })
export class SponsorLocationService extends BaseService<SponsorLocation> {
  constructor() {
    super('locations', SponsorLocation);
  }

  /** GET /admin/sponsors/:sponsorId/locations */
  listLocations(sponsorId: string): Observable<SponsorLocation[]> {
    return this.getMany({ prefix: sponsorPrefix(sponsorId) });
  }

  /** POST /admin/sponsors/:sponsorId/locations */
  createLocation(sponsorId: string, fields: SponsorLocationCreateRequest): Observable<SponsorLocation | null> {
    return this.create(toSponsorLocationCreateRequest(fields), { prefix: sponsorPrefix(sponsorId) });
  }

  /** PUT /admin/sponsors/:sponsorId/locations/:locationId with only the fields that are set. */
  updateLocation(sponsorId: string, locationId: string, fields: SponsorLocationUpdateRequest): Observable<SponsorLocation | null> {
    return this.update(locationId, toSponsorLocationUpdateRequest(fields), { prefix: sponsorPrefix(sponsorId) });
  }

  /** DELETE /admin/sponsors/:sponsorId/locations/:locationId (archive). */
  archiveLocation(sponsorId: string, locationId: string): Observable<void> {
    return this.delete(locationId, { prefix: sponsorPrefix(sponsorId) });
  }
}
